import React from "react";
import { useSelector } from "react-redux";
import { ServiceRequestStats } from "./Stats";
import { CSVLink } from "react-csv";
import FontAwesomeIcon from "../../../../components/Icon";
import moment from "moment";

const headers = [
  { label: "Property Name", key: "propertyName" },
  { label: "Suite Number", key: "suiteNumber" },
  { label: "Suite Civic Address", key: "suiteAddress" },
  { label: "Ticket Number", key: "ticketNumber" },
  { label: "Submitted Date", key: "submittedDate" },
  { label: "Last Updated", key: "lastUpdated" },
  { label: "Status", key: "status" },
  { label: "Days Open", key: "daysOpen" },
];

const transformData = (data) => {
  return data.map((item) => {
    return {
      ...item,
      lastUpdated:
        moment(item.lastUpdated).year() > 2000
          ? moment(item.lastUpdated).format("DD/MM/YYYY")
          : "",
      submittedDate: moment(item.submittedDate).format("DD/MM/YYYY"),
      daysOpen: moment().diff(moment(item.submittedDate), "days"),
    };
  });
};

export const ServiceRequestStatsReportSidebar = () => {
  const report = useSelector((state) => state.serviceRequestStats);
  if (
    !report ||
    !report.serviceRequests ||
    report.serviceRequests.length === 0 ||
    !report.summary
  ) {
    return <></>;
  }
  return (
    <div style={{ justifyContent: "flex-end", display: "flex", margin: 5 }}>
      <CSVLink
        data={transformData(report.serviceRequests)}
        filename={"service_request_stats.csv"}
        separator=","
        asyncOnClick
        headers={headers}
      >
        <div
          style={{
            justifyContent: "flex-end",
            display: "flex",
            margin: 5,
          }}
        >
          <div style={{ paddingRight: 10 }}>Download Report</div>
          <FontAwesomeIcon glyph="cloud-download" weight="regular" size="big" />
        </div>
      </CSVLink>
    </div>
  );
};
